import { computed, observable, reaction } from 'mobx';
import LoadingState from '../../abstract/LoadingState';
import { createObservableInstance } from '../../helpers';

const arrayDiff = (arr1, arr2) => arr1.filter((i) => !arr2.includes(i));

class ArrayListenerState extends LoadingState {
  constructor(root, { expression, ItemClass }) {
    super(root);

    this.root = root.root;
    this.parent = root;

    this.expression = expression;
    this.ItemClass = ItemClass;
  }

  init() {
    super.init();

    this.reactions_.push(
      reaction(
        this.expression,
        (newProperties, oldProperties) =>
          this.handleValue(newProperties, oldProperties),
        { fireImmediately: true }
      )
    );
  }

  get isReady() {
    return !this.data.find(({ isInitialized }) => !isInitialized);
  }

  data = [];

  handleValue(newProperties, old) {
    const oldProperties = !old ? [] : old;
    if (!newProperties) {
      this.data.forEach((i) => i.destroy());
      this.data = [];
    } else {
      const addedItems = arrayDiff(newProperties, oldProperties);
      const removedItems = arrayDiff(oldProperties, newProperties);

      if (this.data.length) {
        removedItems.forEach((id) => {
          const stateItemIndex = this.data.findIndex((s) => s.id === id);
          if (stateItemIndex !== -1) {
            const stateItem = this.data[stateItemIndex];
            this.data.splice(stateItemIndex, 1);
            stateItem.destroy();
          }
        });
      }

      const addedItemsInstances = addedItems.map((id) =>
        createObservableInstance(this.ItemClass, this, id)
      );

      addedItemsInstances.forEach((item) => {
        const { id } = item;
        const idx = newProperties.indexOf(id);
        this.data.splice(idx, 0, item);
      });

      // Check order
      this.data.sort((item1, item2) => {
        const { id: id1 } = item1;
        const { id: id2 } = item2;
        const idx1 = newProperties.indexOf(id1);
        const idx2 = newProperties.indexOf(id2);

        return idx1 - idx2;
      });
    }
  }

  destroy() {
    super.destroy();
    this.data.forEach((i) => i.destroy());
  }
}

ArrayListenerState.annotations = {
  ...LoadingState.annotations,
  data: observable,
  isReady: computed,
};

export default ArrayListenerState;
